module.exports = __webpack_public_path__ + "img/vertical_7_2_5010.f889370d.png";